import clsx from "clsx";
import { ProjectDropdown } from "react-migration/domains/projects/components/ProjectDropdown";
import { LeftHandSideExpandTrayMobile } from "react-migration/layouts/map/Multilayer/Bundle/LeftHandSideExpandTrayMobile";
import { GlobalSearch } from "react-migration/components/GlobalSearch";
import { useSnapshot } from "valtio";
import { mapStore } from "src/js/stores/map/store";
import { useBetaFeatureFlag } from "react-migration/lib/user/useFeatureFlag";
import Feature from "src/js/stores/user/Feature";

export const WorkspaceHeader = ({ activeRoute }: { activeRoute: string }) => {
  const withSearch = activeRoute === "map";
  const { settings } = useSnapshot(mapStore);
  const hasProjectsBeta = useBetaFeatureFlag(Feature.projectsNavBeta);

  if (!hasProjectsBeta || !["map", "sites", "lettersBatches", "sharedSites"].includes(activeRoute)) {
    return null;
  }

  return (
    <div
      className={clsx(
        "md:hidden flex flex-col top-0 right-0 z-99 w-dvw bg-background-surface",
        settings.streetView && "hidden"
      )}
    >
      <ProjectDropdown />
      {withSearch && (
        <div className="h-12 w-full flex flex-row no-wrap gap-4 items-start px-4">
          <LeftHandSideExpandTrayMobile className="relative sm:flex! shadow-none! top-0! left-0! p-2.5! h-11!" />
          <GlobalSearch className={clsx("relative")} inputClassName={clsx("w-full h-11! relative! shadow-none!")} />
        </div>
      )}
    </div>
  );
};
